import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import { gql } from "~/__generated__"
import { settingsPath } from "~/common/paths"
import { useDocumentTitle } from "~/common/use-document-title"
import { useSafeMutation } from "~/common/use-safe-mutation"
import { Button } from "~/ui/button"
import Text from "~/ui/typography"
import { useToast } from "~/ui/use-toast"

const stripeConnectAccountRefreshMutation = gql(/* GraphQL */ `
  mutation StripeConnectAccountRefreshFromComplete {
    stripeConnectAccountRefresh(input: {}) {
      stripeConnectReady
    }
  }
`)

export const StripeOnboardingCompleteScreen: React.FC = () => {
  useDocumentTitle("Stripe onboarding complete")
  const { toast } = useToast()
  const [refresh] = useSafeMutation(stripeConnectAccountRefreshMutation, {
    onError: (error) => {
      toast({
        title: "Error",
        description: error.message,
        variant: "destructive",
      })
    },
  })

  useEffect(() => {
    refresh()
  }, [refresh])

  return (
    <div className="mx-auto mt-10 flex max-w-2xl flex-col gap-4 p-8">
      <Text as="h1" className="text-2xl">
        Stripe onboarding complete
      </Text>
      <Text className="text-gray-400">
        Your payout account setup is complete. It may take a moment for Stripe to finish verifying
        details.
      </Text>
      <Link to={settingsPath({})} className="self-center">
        <Button variant="outline">Back to Settings</Button>
      </Link>
    </div>
  )
}
